import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/live-sessions'

export const listByCourse = async (courseId) => {
  const { data } = await axios.get(`${baseURL}?courseId=${courseId}`, getAuthHeader())
  return data
}

export const getOne = async (sessionId) => {
  const { data } = await axios.get(`${baseURL}/${sessionId}`, getAuthHeader())
  return data
}

export const create = async (payload) => {
  const { data } = await axios.post(baseURL, payload, getAuthHeader())
  return data
}

export const start = async (sessionId) => {
  const { data } = await axios.post(`${baseURL}/${sessionId}/start`, {}, getAuthHeader())
  return data
}

export const complete = async (sessionId) => {
  const { data } = await axios.post(`${baseURL}/${sessionId}/complete`, {}, getAuthHeader())
  return data
}

export const cancel = async (sessionId) => {
  const { data } = await axios.post(`${baseURL}/${sessionId}/cancel`, {}, getAuthHeader())
  return data
}

export const getAgoraToken = async (sessionId) => {
  const { data } = await axios.post(
    '/agora/token',
    { sessionId },
    getAuthHeader()
  )
  return data
}

export const registerJoin = async (sessionId, uid, name) => {
  await axios.post(
    `${baseURL}/${sessionId}/join`,
    { uid, name },
    getAuthHeader()
  )
}

export const registerLeave = async (sessionId, uid) => {
  await axios.post(
    `${baseURL}/${sessionId}/leave`,
    { uid },
    getAuthHeader()
  )
}

export const getParticipants = async (sessionId) => {
  const { data } = await axios.get(`${baseURL}/${sessionId}/participants`, getAuthHeader())
  return data
}
